import { React } from 'react';
import { Flex, Image, Text } from '@chakra-ui/react';
import noInterviewsImage from '../../images/no-interviews.png';

function NoInterviews({ newInterviewer }) {
  const MESSAGES = {
    noInterviews: {
      header: 'You have no interviews at the moment!',
      description:
        ' As soon as your interviews start being scheduled, you will see them listed here. The most recent will show at the top. Update statuses and submit your feedback reports once interviews are done. Enjoy!',
    },
    noFilteredInterviews: {
      header: 'You have no interviews for the filters applied!',
    },
  };

  return (
    <Flex
      flexDirection='column'
      alignItems='center'
      maxWidth='715px'
      mx='auto'
      mt={newInterviewer ? '200px' : '100px'}
      textAlign='center'>
      <Image src={noInterviewsImage} alt='No Interviews' />
      <Text fontSize='20px' fontWeight='700' mt='40px' mb='16px'>
        {newInterviewer ? MESSAGES.noInterviews.header : MESSAGES.noFilteredInterviews.header}
      </Text>
      <Text fontSize='20px' color='gray.600'>
        {newInterviewer ? MESSAGES.noInterviews.description : null}
      </Text>
    </Flex>
  );
}

export default NoInterviews;
